module.exports = __webpack_public_path__ + "static/media/ShuiabMoosa 12.95kg 7th.7e1570d7.jpg";